export default "__VITE_ASSET__126f32ce__"